import React, {useEffect, ReactElement, useState } from "react";
import { useDispatch } from "react-redux";

import DatePicker from "../helpers/genericDatePicker"
import { getAdboxReport as fetchAdboxReport } from "../../actions/monetization";

import styles from "../../styles/admanager/UserEarningsReport.module.scss"
import { nonAggregatable, ReportColumns } from "../../constants/earningsReport";
// import GenericInput from "../helpers/genericInput";
import TabOptions from '../../components/TabOptions';

const ADBOX_REPORT_EPOCH = new Date("2022-03-01 00:00")

type ColumnCheckedInfo = Record<ReportColumns,boolean>

const initialChecked = nonAggregatable.reduce<ColumnCheckedInfo>((map, column) => {
  map[column] = false
  return map
}, {} as ColumnCheckedInfo)

function getExcludedColumns(selected: ColumnCheckedInfo): string[] {
  let excludeColumns:string[] = [];
  for (const [key, value] of Object.entries(selected)) {
    if (!value) {
      excludeColumns.push(key);
    }
  }

  return excludeColumns
}

function getLastMonth() {
  const today = new Date()
  const lastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1)
  return lastMonth
}

function renderDatePicker(label:ReactElement|string, initialDate:Date, minDate:Date, maxDate:Date, setDateFunc:(newDate:Date)=>void):ReactElement {
  const datePickerStyles = {
    calendarDropdownStyle: styles.calendarDropdown,
    dayStyle: styles.calendarDay,
    dayDisableStyle: styles.calendarDayDisable,
    generalClassName: styles.calendar,
    selectedStyle: styles.selectedStyle,
    calendarError: styles.calendarError,
    disableDates: styles.disableDate,
  };
  return (
    <DatePicker
      title={label}
      minDate={minDate}
      maxDate={maxDate}
      inputValue={initialDate}
      datePickerStyles={datePickerStyles}
      handleFieldChange={setDateFunc}
      monthYearPicker={true}
      formatDate='MMMM yyyy'
    />
  )
}

// function renderColumnPicker({column, selected, onChange}:{column:ReportColumns,selected:ColumnCheckedInfo,onChange:(column:ReportColumns, checked:boolean)=>void}) {
//   const checked = selected[column]
//   const changeValue = () => {
//     if (typeof column==="string"){
//       onChange(column as ReportColumns, !checked);
//     }
//   }
//   return (
//     <div key={column} className={styles.checkboxWrapper}>
//       <input
//         type="checkbox"
//         name={column}
//         id={column}
//         checked={checked}
//         onChange={changeValue}
//       />
//       <label className={styles.checkbox} htmlFor={column}>
//       <span></span>
//         </label>
//             {reportColumnMetaData[column].title}
//       </div>    
//   )
// }


export function UserEarningsReportForm(): ReactElement {
  const dispatch = useDispatch()
  // const [reportOptions, setReportOptions] =  useState ([
  //   { name: "Country", selected: true },
  //   { name: "Ad Type", selected: true },
  //   { name: "Device Type", selected: false},
  // ]);

  /*
   report fetch stuff
  */
  const [start, setStart] = useState<Date>(getLastMonth())
  const [end, setEnd] = useState<Date>(getLastMonth())
  const [selected, setSelected] = useState<ColumnCheckedInfo>(initialChecked)
  
  useEffect(() => {
    dispatch(fetchAdboxReport(start, end, getExcludedColumns(selected)))
  }, [dispatch, selected, start, end ])

  // function generateReport():void {

  //   dispatch(fetchAdboxReport(start, end, excludeColumns))
  // }


  function setColumnChecked(column:ReportColumns, checked:boolean):void {
    setSelected({
      ...selected,
      [column]: checked
    })
  }

  const convertToObj = () => {
    let obj:any  = {};

    for (const [key, value] of Object.entries(selected)) {
        obj[key] = value;
      }

    return obj
  }


  // const { activeSubtab, setSubTab } = useContext(RouteContext);
  // const { workState } = useSelector(selectCurrentState);

  const handleClick = (name: any) => {

    for (const [key, value] of Object.entries(selected)) {
      if(key === name){
        setColumnChecked(name as ReportColumns, !value );
      }
    }
  }

  return (
    <>
      <div className={styles.reportHeading} >
        <h2>Monthly Reports</h2>
        {/* <div className={styles.buttonContainer}> */}
     
        {/* </div> */}
      </div>
      <div className={styles.reportControlsContainer} >
        <p style={{ color: 'white' }}>Select a date range for your report: </p>
        <div className={styles.reportControls}>
          <div className={styles.dateRange}>
            <div className={styles.firstPicker}>
              {renderDatePicker("Report Start Date", start, ADBOX_REPORT_EPOCH, end, setStart)}
            </div>
            <div>
              {renderDatePicker("End Date", end, start, getLastMonth(), setEnd)}
            </div>
          </div>
        </div>
        <p className={styles.breakoutButtonsLabel}>Select which metrics you would like to include / breakout:</p>
        <div className={styles.breakoutButtonsContainer}>
          <TabOptions
            options={nonAggregatable}
            handleClick={(e: any) => handleClick(e)}
            optionsObject={convertToObj()}
          />
        </div>
      </div>
      {/* <div className={classnames(styles.reportForm, shared.subtext)}>
        <div>
        
          <p>
          Then click the "Generate Report" button.
          </p> 
        </div>

        <button
          onClick={generateReport}
          className={styles.btnGenerateReport}>
          Generate Report
        </button>
      </div> */}
    </>
  )
}
